var timeout = false, rtime,delta = 500;

$(function(){ 

	$('.mobile-menu-modal').on('shown.bs.modal', function (e) {
	  	$('.mobile-menu-trigger').addClass('menu-visible');
	});
	
	$('.mobile-menu-modal').on('hidden.bs.modal', function (e) {
	  	$('.mobile-menu-trigger').removeClass('menu-visible');
	});

	$('.mobile-menu-modal .messages-notifications').on('click', function () {
		$('.mobile-menu-modal').modal('hide');
		$('.mobile-menu-modal').on('hidden.bs.modal', function () {
			 $('.notification-modal').modal('show');
		});
		return false;
	});  
	
	$('.expand-menu-toggle').on('click', function () {
		$('.desktop-menu.menu-side-w.menu-activated-on-click').toggleClass('expanded');
		return false;
	});

    $('.go-to-anchor').click(function(){
        var anchor = $(this).attr('href');
        $("html, body").animate({ scrollTop: $(anchor).offset().top }, 1000);    
        return false;
    });    

    $('.iframe-lang-switch ul li span.lang').click(function(){
        var $this = $(this);
        
        $('.iframe-lang-switch ul li span.lang').removeClass('active');
        
        $this.addClass('active');
        
        var $source = $this.data('source');

        $this.closest('.embed-block').find('iframe').attr('src',$source);

        return false;

    });

    initForm('body');

    
}); 

function waypoints(){

    $('.way-point:not(.way-point-ready)').each(function(){
        
        $(this).waypoint(function() {
            
            $(this.element).addClass('shown');

        }, {offset: '90%'}); 
        
        $(this).addClass('way-point-ready');

    });
    
}

function initForm(target){
	'use strict';

	waypoints();

	$('.select2,select[data-plg="select2"]:visible').each(function(){
		var data = $(this).data();
	    var options = {};
	    if(data.ajax){
	        options = $.extend(false, options ,{
	            placeholder: data.placeholder,
	            allowClear: data.allowClear || false,
	            ajax: {
	                url : API + '/'+ data.ajax,
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    var search_for = typeof(params.term)!=='undefined'?params.term:'';
	                    return {
	                        q: data.search+'=@'+search_for,
	                        page: params.page
	                    };
	                },
	                processResults: function (res, params) {
	                    params.page = params.page || 1;
	                    var value_field = data.value || 'id';
	                    var label_field = data.label || data.search;
	                    return {
	                        results:  $.map(res.data, function (item) {
	                            return { 
	                                all_data: item,
	                                text: item[label_field],
	                                id: item[value_field]
	                            }
	                        }),
	                        pagination: {
	                            more: (params.page * 30) < data.total_count
	                        }
	                    };
	                },
	                cache: true
	            },
	            minimumInputLength: 0
	        });
	    }
	    $(this).select2(options);
	});

}

function actionResponseModal(msg, type, container){
	var $timeout = 0;
	
	/*if($('body').hasClass('modal-open') ){
		$('.modal').modal('hide');
		$timeout = 500;	
	}*/
	var with_ajax_modal = false;
	if($('#ajaxModal:visible').length == 1){
		with_ajax_modal = true;
		$('#ajaxModal').animate({opacity:0},300);
	}

	setTimeout(function(){

        var $d = '<div class="modal fade" id="responseModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">\
                <div class="modal-dialog modal-md" role="document">\
                    <div class="modal-content">\
                        <a href="#" class="close-modal" tabindex="0" onClick="$(\'#responseModal\').modal(\'hide\');return false;">\
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" viewBox="0 0 13 13" style="enable-background:new 0 0 13 13;" xml:space="preserve">\
                                <path class="st0" d="M12.9,11.7l-1.2,1.2L6.9,8.1l-4.8,4.8l-1.2-1.2l4.8-4.8L0.9,2.1l1.2-1.2l4.8,4.8l4.8-4.8l1.2,1.2L8.1,6.9 L12.9,11.7z"></path>\
                            </svg>\
                        </a>\
                        <div class="modal-body"></div>\
                    </div>\
                </div>\
            </div>';
        if( $('#responseModal').length == 0 ){
            $('body').append($d);
        }
        
		var _container = container || '';
		if(type == 'success'){
			var icon = '<i class="fa fa-check-circle" aria-hidden="true"></i>';	
		}else{
			var icon = '<i class="fa fa-exclamation-circle" aria-hidden="true"></i>';	
		}
		var content = '<div class="alert alert-'+type+'"><h3>'+msg+'</h3></div>'
		$('#responseModal .modal-body').html(content);	
		$('body').addClass('dark-backdrop');
		$('#responseModal').modal('show');
		$('#responseModal').on('hidden.bs.modal', function () {
			$('#responseModal .modal-body').empty();
			$('body').removeClass('dark-backdrop');
			if(with_ajax_modal){
				$('#ajaxModal').animate({opacity:1},300);
			}
		});
	},$timeout);

}

 function loadScript(url, callback) {
    jQuery.ajax({
        url: url,
        dataType: 'script',
        success: callback,
        async: true
    });
}
function load_css (t){
	$('head').append('<link rel="stylesheet" href="'+t+'" type="text/css" />');
}
function createCookie(name, value, hours) {
    var expires;

    if (hours) {
        var date = new Date();
        date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}
var AjaxForms = {

    options : {
        target        : null,
        stop_response : false,
        empty_form 	  : true,
        successFn     : null,
        errorFn       : null,
        method        : 'POST',
        recaptcha     : false
    },
    
    init:function(t){
        var $this = this;
        if($this.options.recaptcha ===  true){
            
            $.ajax({
                url: 'https://www.google.com/recaptcha/api.js',
                dataType: "script",
                success:function(){
					try{
					grecaptcha.render();
					}catch(Error){}

                }
            });
        }

        $this.options.target = t;

        $($this.options.target).parsley({
			excluded: "textarea:hidden, input:hidden, select:hidden"
		});
        $($this.options.target).on('submit',function($e){

            $this.submit_form();
            $e.preventDefault(); 

        }).addClass('ready');
    },
    form_submit_response : function( msg , type){
        actionResponseModal(msg,type);
    },
    submit_form:function(){

        var $this       = this,
            $form       = $($this.options.target),
            successFn   = $this.options.successFn,
            errorFn     = $this.options.errorFn,
            url         = $form.attr('action'),
            postData    = $form.serialize(),
            method      = $form.attr('method'),
            $submitBTN  = $form.find('button[type="submit"]');

		if(!$submitBTN.hasClass('like-btn')){
			
			$submitBTN.prop('disabled',true);
			$submitBTN.data('initialText',$submitBTN.html());
			$submitBTN.html('<i class="fa fa-spinner fa-spin"></i> '+ ['working on it']);
		}
		
		
        $.ajax({
            url     : url,
            dataType: "json",
            data    : postData,
            type    : method,
            success: function (data) {			
				
                if($this.options.recaptcha ===  true){
                    grecaptcha.reset();
                }
				
                $submitBTN.html($submitBTN.data('initialText'));
               
				if($this.options.empty_form){
					$form.find('input,textarea,select').not(':hidden').each(function(){
	                    $(this).val('');
	                    $(this).removeClass('parsley-success');
	                });	
				} 

                if(typeof(successFn) !== 'undefined'){
                    successFn(data);
                }                
                if(!$this.options.stop_response){
                	$this.form_submit_response( data.message || 'submitted', 'success');		
                }
            },
            error: function (response) {
                if($this.options.recaptcha ===  true){

                    grecaptcha.reset();
                }
                $submitBTN.prop('disabled',false);	
                var responseJSON = jQuery.parseJSON(response.responseText);
                
                $submitBTN.html($submitBTN.data('initialText'));

                if(typeof(errorFn) !== 'undefined'){

                    errorFn( responseJSON );
                    
                }else{
                    for(var i in responseJSON.errors){
                        if(i == 'g-recaptcha-response'){
                            return actionResponseModal('Are you a robot?','error');
                        }else{
                            var t = $form.find('[name="'+i+'"]').closest('.form-group');
                            
                            $form.find('[name="'+i+'"]').addClass('parsley-error');

                            var error_string = typeof( responseJSON.errors[i]) ==='string' ?  responseJSON.errors[i] : responseJSON.errors[i].join('')

                            if(t.find('.parsley-errors-list').length > 0){
                                t.find('.parsley-errors-list').html('<div class="parsley-type">'+error_string+'</div>');
                            }else{

                                t.append('<div class="parsley-errors-list filled text-left"><div class="parsley-type">'+error_string+'</div></div>');    
                            }

                        }
                    }
                }
            }
        });
    } 
}
var heartbeat = {
		config:{
		delay : 20
	},

	init:function(){
		this.poll();
		this.long_poll();
	},
	long_poll : function(){
		var $this 		= this;

		try{
			ga('send', 'event', 'Heartbeat', 'Heartbeat', '', {
			  nonInteraction: true
			});
		}	catch(Error){}

	
		setTimeout(function(){
			
			$this.long_poll();
		
		} , 5 * 60 * 1000);
	},
	poll : function(){
		var $this 		= this;
		var fetch_url 	= '/heartbeat?v=' + (new Date().toISOString().slice(0,18));
		
		$.ajax({
		  url: fetch_url
		}).done(function(response) {

			if(navigator.userAgent != response.useragent){
				document.getElementById('logout-form').submit();
			}

		}).always(function(response) {
			
			setTimeout(function(){
			
				$this.poll();
			
			} , $this.config.delay * 1000);

		});

	}

	
};
var notifications = {
	
	config:{
		delay : 10,
		client_id : 0,
		user_groups : [],
		user_id : 0,
		env : '',
		base_url : 'https://notifications.cornerstoneav.com/'
	},

	notifications_list 		: [],
	notifications_list_raw 	: [],

	init:function(){
		this.poll();
	},

	discard_notification:function(notification_item){
		localStorage.setItem('notification_item_' + notification_item , 'discard');
	},
	callback : function(notification_item){
		var $this = this;
		var notification = $this.notifications_list_raw.filter(function(i){ return i.id == notification_item})[0];
		switch(true){
			case 'navigation' == notification.payload.action || 'auto-redirect' == notification.payload.action:
				localStorage.setItem('notification_item_' + notification.id , 'interaction');
				if(notification.payload.nodeid && notification.payload.nodeid.length > 0){
					window.location = notification.payload.url + '?nodeid=' + notification.payload.nodeid;
				}else{
					window.location = notification.payload.url;
				}
				break;
			
			case 'function' == notification.payload.action:
				localStorage.setItem('notification_item_' + notification.id , 'function');
				var fn = notification.payload.fn;
				window[fn](notification.payload.params)
				break;

		}
	},

	valid_notifications : function(notifications){
		
		return notifications.filter(function(item){
		
			if( localStorage.getItem('notification_item_' + item.id ) !== null ){
				return false;
			}
			var now 	= moment(moment().tz( 'America/Los_Angeles' ).format("MM/DD/YYYY HH:mm"), "MM/DD/YYYY HH:mm");
			var start 	= moment(item.starts_at, "MM/DD/YYYY HH:mm");
			var end 	= moment(item.ends_at, "MM/DD/YYYY HH:mm");
			
			return (now.isBetween(start, end , undefined , '[]'));
		});
	},

	add_modal_notification:function(notification){
	
		var markup = '<div class="modal fade notification-modal" id="notification-popover-'+notification.id+'" role="dialog">'
						  +'<div class="modal-dialog" role="document">'
						    +'<div class="modal-content">'
						      +'<div class="modal-body">'
						      		+'<img src="'+notification.image+'" style="width:100%;cursor:pointer"   onclick="notifications.callback(\''+notification.id+'\');" data-id="'+ notification.id +'">  '
						          +'	<button type="button" class="close" data-dismiss="modal" aria-label="Close" onclick="notifications.discard_notification(\''+notification.id+'\');">'
						         +' <svg style="fill: #ffffff" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 13 13" style="enable-background:new 0 0 13 13;" xml:space="preserve">'
						            +'   <path class="st0" d="M12.9,11.7l-1.2,1.2L6.9,8.1l-4.8,4.8l-1.2-1.2l4.8-4.8L0.9,2.1l1.2-1.2l4.8,4.8l4.8-4.8l1.2,1.2L8.1,6.9 L12.9,11.7z"></path>'
						           +'   </svg>'
						          +'</button>'
						  		+'<div class="notification-content">'+notification.content+'</div>'
						     +' </div>'
						   +' </div>'
						  +'</div>'
						+'</div>';

		$('body').append(markup);
		
		$('#notification-popover-' + notification.id).modal('show');

	},

	close_modal_notification:function(){

	},
	
	poll : function(){
		

		var $this = this;

		var promises = [

		];

		var fetch_url = $this.config.base_url+$this.config.client_id+'/'+$this.config.env+'/user-'+$this.config.user_id+'/notification.json?v=' + (new Date().toISOString().slice(0,18));

		/*promises.push(fetch(fetch_url).then(function(resp){
	  		return resp.json();
	  	}));
*/
		for(var i in $this.config.user_groups){

			var fetch_url = $this.config.base_url+$this.config.client_id+'/'+$this.config.env+'/group-'+$this.config.user_groups[i]+'/notification.json?v=' + (new Date().toISOString().slice(0,18));

			promises.push(fetch(fetch_url).then(function(resp){
		  		return resp.json();
		  	}));
		}

		Promise.all(promises).then(function(fetches){
			
			var retrieved_notifications = [];

			for(var ii in fetches){
				
				var response = fetches[ii];
				var init_slider = false;
				var data = $this.valid_notifications(response);

				for(var i in data){
					
					var notification 			= data[i];							
					var notification_id 		= Number(notification.id);
					var notification_content 	= notification.content;
					
					retrieved_notifications.push( notification_id );

					if($this.notifications_list.indexOf( notification_id ) == -1){
						
						$this.notifications_list.push( notification_id );
						$this.notifications_list_raw.push( notification );
						
						if(notification.type == 'modal'){
							
							$this.add_modal_notification(notification);

						}else if(notification.type == 'top-nav'){
							
							$('.notifications-slider').show();
							$('.notifications-slider-content').append('<div class="slick-slide" style="cursor:pointer" onclick="notifications.callback('+notification_id+');" data-id="'+ notification_id +'" >'+notification_content+'</div>' );

							if(notification.payload.action == 'auto-redirect'){
								
								setTimeout(function(){
									
									notifications.callback(notification_id);

								},5000);
							}
							
							init_slider = true;
						}
					}
				}
			}

			$('.notifications-slider .notifications-slider-content .slick-slide').each(function(){
				if(retrieved_notifications.indexOf( Number( $(this).data('id'))) == -1){
					$(this).remove();
				}
			});

			if(init_slider && $('.notifications-slider .notifications-slider-content .slick-slide').length > 0 ){
				
				var $slider_content = $('.notifications-slider .notifications-slider-content');

				$('.notifications-slider').show();
				
				if ($slider_content.hasClass('slick-initialized')) {
					$slider_content.slick('destroy');
				}  

				$slider_content.slick({			
					dots: false,
					arrows: false,
					infinite: true,
					speed: 300,
					swipe:false,
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplay: true,
				  	fade: true,
		  			autoplaySpeed: 5000,	

				});		
			}else if( $('.notifications-slider .notifications-slider-content .slick-slide').length == 0 ){
				$('.notifications-slider').hide();
				if ($slider_content.hasClass('slick-initialized')) {
					$slider_content.slick('destroy');
				}  
			}
			
			$this.delayed_poll();

		}).catch(function(error) {
			$this.delayed_poll();
		});
	},

	delayed_poll:function(){

		var $this = this;

		setTimeout(function(){
			
			$this.poll();
		
		} , $this.config.delay * 1000);
	}

};
var partials_pull  = [];    

function loading_partial(){
    if($.isEmptyObject(partials_pull)){
        $('body').removeClass('partials-loading');
    }else if(!$.isEmptyObject(partials_pull) ){
        $('body').addClass('partials-loading')
    }
}

    
function append_partial( container , cb){

    if(container.length == 0){
        return false;
    }

    var unique_partial_id = Math.floor(Math.random()* 1000000),
        d = container.data(),
        data = {};

    for(var i in d){
        if(i!='partial'){
            data[i] = d[i];
        }
    }
    

    $('body').addClass('loading');
    container.css('opacity',0.5);
    container.css('pointer-events','none');
    container.css('min-height',container.height());
    container.addClass('loading');
    container.append('<div class="parial-loader">Loading...</div>');

    if (container.attr('id') == "products-list-filter") {
        container.append(products_loading_template);
    }
    if (container.attr('data-partial') == "products.aggregates") {
        container.append(products_filter_loading_template);
    }



    if(data){
        data.current_url = window.location.pathname;
    }
    if(container.data('xhr')){
        container.data('xhr').abort();
    }

    var ext_domain = '';
    if (container.data('ext_domain')) {
        ext_domain = container.data('ext_domain');
    }

   $.ajax({
        url     : ext_domain + '/partial/' + d.partial,
        data    : data,
        method  : 'GET',

        success: function (data) {
            var newContent = $(data).html();
            var t = container.append(newContent);
            
           container.css('pointer-events','auto');
            

            container.removeClass('loading');
            $('body').removeClass('loading');
            container.find('.parial-loader').remove();

            container.animate({'opacity':1},500);
            container.css('pointer-events','auto');
            container.css('min-height','auto');



            $('#' + newContent.attr('id')).removeClass('loading');

            container.css('min-height','0');

            if(typeof(cb) !== 'undefined'){
                cb(newContent);
            }

            loading_partial();
        },
        error: function (response) {
            loading_partial();
        }
    });

    loading_partial();
    
}
function load_partial( container , cb){

    if(container.length == 0){
        return false;
    }

    var unique_partial_id = Math.floor(Math.random()* 1000000),
        d = container.data(),
        data = {};

    for(var i in d){
        if(i!='partial'){
            data[i] = d[i];
        }
    }
    

    $('body').addClass('loading');
    container.css('opacity',0.5);
    container.css('pointer-events','none');
    container.css('min-height',container.height());
    container.addClass('loading');
    container.append('<div class="parial-loader">Loading...</div>');

    if (container.attr('id') == "products-list-filter") {
        container.append(products_loading_template);
    }
    if (container.attr('data-partial') == "products.aggregates") {
        container.append(products_filter_loading_template);
    }



    if(data){
        data.current_url = window.location.pathname;
    }
    if(container.data('xhr')){
        container.data('xhr').abort();
    }

    var ext_domain = '';
    if (container.data('ext_domain')) {
        ext_domain = container.data('ext_domain');
    }

   $.ajax({
        url     : ext_domain + '/partial/' + d.partial,
        data    : data,
        method  : 'GET',

        success: function (data) {
            var newContent = $(data.markup);
            var t = container.replaceWith(newContent);
            
           container.css('pointer-events','auto');
            if(newContent.text().length == 0){
                container.hide();
            }else{
                container.show();
            } 

            container.removeClass('loading');
            $('body').removeClass('loading');
            container.find('.parial-loader').remove();
           $('#' + newContent.attr('id')).removeClass('loading');

            container.css('min-height','0');

            if(typeof(cb) !== 'undefined'){
                cb(newContent);
            }

            loading_partial();
            initForm(container);
        },
        error: function (response) {
            loading_partial();
        }
    });

    loading_partial();
    
}
function countdown(targetDate){
  var second = 1000, 
  minute = second * 60, 
  hour = minute * 60, 
  day = hour * 24,
  countDown = new Date(targetDate).getTime(),
  x = setInterval(function() {    
    var now = new Date().getTime(), distance = countDown - now;

    document.getElementById("days").innerText = Math.floor(distance / (day)),
    document.getElementById("hours").innerText = Math.floor((distance % (day)) / (hour)),
    document.getElementById("minutes").innerText = Math.floor((distance % (hour)) / (minute)),
    document.getElementById("seconds").innerText = Math.floor((distance % (minute)) / second);

    if (distance < 0) {         
      clearInterval(x);
    }

  }, 0);
};


function countdownTimer(targetDate) {
  console.log('timer', targetDate);
  var millisecond = 1;
  var second = 1000;
  var minute = second * 60;
  var hour = minute * 60;
  var day = hour * 24;

  //let targetDate = "{{ $component_data['date'] ?? 'Apr 18, 2021 00:00:00 PST' }}";
  var countDown = new Date(targetDate).getTime();

  var secondTicker = 0;
  var minuteTicker = 0;
  var seconds = 0;

  var secondPercent = 0;
  var minutePercent = 0;
  var hourPercent = 0;
  var dayPercent = 0;


  var cSecond = 0;
  var cMinute = 0;
  var cHour = 0;
  var cDay = 0;

  var prevSecond = 1;

  var x = setInterval(function () {

    var now = new Date().getTime();
    var distance = countDown - now;

    cSecond = Math.floor((distance % minute) / second);
    cMinute = Math.floor((distance % hour) / minute);
    cHour = Math.floor((distance % day) / hour);
    cDay = Math.floor(distance / day);


    if (prevSecond > 0 && prevSecond > cSecond) {

      prevSecond--;
      secondPercent = cSecond / 60;
      minutePercent = cMinute / 60;
      hourPercent = cHour / 24;
      dayPercent = cDay / 42;

      //console.log(cSecond, cMinute, minutePercent);
    } else {
      prevSecond = 60;
    }

    update(secondPercent - 1);
    updateMinutes(minutePercent - 1);
    updateHours(hourPercent - 1);
    updateDays(dayPercent - 1);

    (document.getElementById("days").innerText = Math.floor(distance / day)),
    (document.getElementById("hours").innerText = Math.floor((distance % day) / hour)),
    (document.getElementById("minutes").innerText = Math.floor((distance % hour) / minute)),
    (document.getElementById("seconds").innerText = Math.floor((distance % minute) / second));

    //do something later when date is reached
    if (distance < 0) {
      console.log("Countdown Done.");
      clearInterval(x);
    }

  }, 20);

  /////////////////////////////////
  // SVG GARBAGE BEGIN //
  ////////////////////////////////


  var wrapper = document.getElementById('progressSeconds');
  var wrapperMinutes = document.getElementById('progressMinutes');
  var wrapperHours = document.getElementById('progressHours');
  var wrapperDays = document.getElementById('progressDays');
  var start = 0;
  var end = parseFloat(wrapper.dataset.percentage);

  var wrapperPar = document.getElementById('seconds');
  var wrapperParSize = wrapperPar.offsetWidth;
  var sizeCalc = (wrapperParSize + 11) / 2;

  var props = {
    fill: '#25bbd9',
    track: '#0b3b4e',
    stroke: '#010714',
    trackWidth: 12,
    strokeSpacing: 1,
    radius: sizeCalc,
    fillStart: '#3ff2a2',
    fillEnd: '#1ca3f9',
  }

  var radius = props.radius;
  var border = props.trackWidth;
  var strokeSpacing = props.strokeSpacing;
  var endAngle = Math.PI * 2;
  //var formatText = d3.format('.0%');
  var boxSize = radius * 2;
  var count = end;
  var progress = start;
  var step = end < start ? -0.01 : 0.01;

  //Define the circle
  var circle = d3.svg.arc()
    .startAngle(0)
    .innerRadius(radius)
    .outerRadius(radius - border);

  //setup SVG wrapper
  var svg = d3.select(wrapper)
    .append('svg')
    .attr('width', boxSize)
    .attr('height', boxSize);

  //BEGIN FILL GRADIENT
  var lg = svg.append("defs").append("linearGradient")
    .attr("id", "mygrad")
    .attr("x1", "0%")
    .attr("x2", "0%")
    .attr("y1", "0%")
    .attr("y2", "100%");
  lg.append("stop")
    .attr("offset", "0%")
    .style("stop-color", props.fillStart)
    .style("stop-opacity", 1)

  lg.append("stop")
    .attr("offset", "100%")
    .style("stop-color", props.fillEnd)
    .style("stop-opacity", 1)
  //END FILL GRADIENT

  // ADD Group container
  var g = svg.append('g')
    .attr('transform', 'translate(' + boxSize / 2 + ',' + boxSize / 2 + ')');

  //Setup track
  var track = g.append('g').attr('class', 'radial-progress');
  track.append('path')
    .attr('class', 'radial-progress__background')
    .attr('fil', "url(#mygrad)")
    .attr('stroke', props.stroke)
    .attr('stroke-width', 10 + 'px')
    .attr('d', circle.endAngle(endAngle));

  //Add colour fill
  var value = track.append('path')
    .attr('class', 'radial-progress__value')
    .attr('fil', "url(#mygrad)")
    .attr('stroke', props.stroke)
    .attr('stroke-width', props.strokeSpacing + 'px');

  function update(progress) {
    //update position of endAngle
    if (value) {
      value.attr('d', circle.endAngle(endAngle * progress));
    }

  }


  //Define the circle
  var circleMinutes = d3.svg.arc()
    .startAngle(0)
    .innerRadius(radius)
    .outerRadius(radius - border);

  //setup SVG wrapper
  var svgMinutes = d3.select(wrapperMinutes)
    .append('svg')
    .attr('width', boxSize)
    .attr('height', boxSize);

  // ADD Group container
  var gMinutes = svgMinutes.append('g')
    .attr('transform', 'translate(' + boxSize / 2 + ',' + boxSize / 2 + ')');

  //Setup track
  var trackMinutes = gMinutes.append('g').attr('class', 'radial-progress');
  trackMinutes.append('path')
    .attr('class', 'radial-progress__background')
    .attr('fil', "url(#mygrad)")
    .attr('stroke', props.stroke)
    .attr('stroke-width', 10 + 'px')
    .attr('d', circleMinutes.endAngle(endAngle));

  //Add colour fill
  var valueMinutes = trackMinutes.append('path')
    .attr('class', 'radial-progress__value')
    .attr('fil', "url(#mygrad)")
    .attr('stroke', props.stroke)
    .attr('stroke-linecap', 'round')
    .attr('stroke-width', props.strokeSpacing + 'px');

  function updateMinutes(progressMinutes) {
    //update position of endAngle
    valueMinutes.attr('d', circleMinutes.endAngle(endAngle * progressMinutes));
  }




  //Define the circle
  var circleHours = d3.svg.arc()
    .startAngle(0)
    .innerRadius(radius)
    .outerRadius(radius - border);

  //setup SVG wrapper
  var svgHours = d3.select(wrapperHours)
    .append('svg')
    .attr('width', boxSize)
    .attr('height', boxSize);

  // ADD Group container
  var gHours = svgHours.append('g')
    .attr('transform', 'translate(' + boxSize / 2 + ',' + boxSize / 2 + ')');

  //Setup track
  var trackHours = gHours.append('g').attr('class', 'radial-progress');
  trackHours.append('path')
    .attr('class', 'radial-progress__background')
    .attr('fil', "url(#mygrad)")
    .attr('stroke', props.stroke)
    .attr('stroke-width', 10 + 'px')
    .attr('d', circleHours.endAngle(endAngle));

  //Add colour fill
  var valueHours = trackHours.append('path')
    .attr('class', 'radial-progress__value')
    .attr('fil', "url(#mygrad)")
    .attr('stroke', props.stroke)
    .attr('stroke-width', props.strokeSpacing + 'px');

  function updateHours(progressHours) {
    //update position of endAngle
    valueHours.attr('d', circleHours.endAngle(endAngle * progressHours));
  }


  //Define the circle
  var circleDays = d3.svg.arc()
    .startAngle(0)
    .innerRadius(radius)
    .outerRadius(radius - border);

  //setup SVG wrapper
  var svgDays = d3.select(wrapperDays)
    .append('svg')
    .attr('width', boxSize)
    .attr('height', boxSize);

  // ADD Group container
  var gHours = svgDays.append('g')
    .attr('transform', 'translate(' + boxSize / 2 + ',' + boxSize / 2 + ')');

  //Setup track
  var trackDays = gHours.append('g').attr('class', 'radial-progress');
  trackDays.append('path')
    .attr('class', 'radial-progress__background')
    .attr('fil', "url(#mygrad)")
    .attr('stroke', props.stroke)
    .attr('stroke-width', 10 + 'px')
    .attr('d', circleDays.endAngle(endAngle));

  //Add colour fill
  var valueDays = trackDays.append('path')
    .attr('class', 'radial-progress__value')
    .attr('fil', "url(#mygrad)")
    .attr('stroke', props.stroke)
    .attr('stroke-width', props.strokeSpacing + 'px');

  function updateDays(progressDays) {
    //update position of endAngle
    valueDays.attr('d', circleDays.endAngle(endAngle * progressDays));
  }
};